export const GOOGLE_MAP_COUNTRY_NAMES: Record<string, string | string[]> = {
  Czechia: 'Czech Republic',
  Türkiye: 'Turkey',
  'U.S. Virgin Islands': 'Virgin Islands',
  'Turks and Caicos Islands': 'Turks and Caicos',
  'British Virgin Islands': 'Tortola',
  'St Lucia': 'St. Lucia',
  'Saint Lucia': 'St. Lucia',
  Spain: ['Spain-Mainland', 'Spain-Canary Islands', 'Spain-Balearic Islands'],
  'Northern Mariana Islands': 'Saipan',
  'Sint Maarten': 'Saint Martin (Netherlands)',
  'Saint Martin': 'Saint Martin (French)',
  'Saint Barthélemy': 'Saint Barthelemy',
  Réunion: 'Reunion',
  Portugal: ['Portugal', 'Portugal-Azores Islands'],
  'North Macedonia': 'Macedonia',
  "Côte d'Ivoire": 'Ivory Coast',
  Greece: ['Greece - Crete Island', 'Greece'],
  France: ['France - Corsica', 'France'],
  Curaçao: 'Curacao',
  'Democratic Republic of the Congo': 'Congo',
  'The Bahamas': 'Bahamas',
  'Svalbard and Jan Mayen': 'Norway',
}

export const CITIES_WITHOUT_COORDINATES: Record<string, string> = {
  As: 'Ås',
}

export const GOOGLE_MAP_CITY_NAMES: Record<string, string | string[]> = {
  As: 'Ås',
  Venezia: ['Venice', 'Mestre Venice'],
  Agrigento: 'Agrigento - Sicily',
  Palermo: 'Palermo - Sicily',
  Alghero: 'Alghero - Sardinia',
  Augusta: 'Augusta - Sicily',
  Baia: 'Baia - Sardinia',
  Budoni: 'Budoni - Sardinia',
  Cagliari: 'Cagliari - Sardinia',
  Caltanissetta: 'Caltanissetta - Sicily',
  Castelvetrano: 'Castelvetrano - Sicily',
  Cinisi: 'Cinisi - Sicily',
  Comiso: 'Comiso - Sicily',
  "Cortina d'Ampezzo": 'Cortina D’ampezzo',
  Gela: 'Gela - Sicily',
  'Giardini Naxos': 'Giardini Naxos - Sicily',
  Lipari: 'Lipari - Sicily',
  Macomer: 'Macomer - Sardinia',
  Messina: 'Messina - Sicily',
  Milazzo: 'Milazzo - Sicily',
  Noto: 'Noto - Sicily',
  Nuoro: 'Nuoro - Sardinia',
  Olbia: 'Olbia - Sardinia',
  Oristano: 'Oristano - Sardinia',
  Palau: 'Palau - Sardinia',
  Pantelleria: 'Pantelleria - Sicily',
  'Porto Cervo': 'Porto Cervo - Sardinia',
  'Porto Rotondo': 'Porto Rotondo - Sardinia',
  Ragusa: 'Ragusa - Sicily',
  'Santa Teresa Gallura': 'Santa Teresa Di Gallura - Sardinia',
  Siracusa: 'Siracusa - Sicily',
  'Tempio Pausania': 'Tempio Pausania - Sardinia',
  Tortolì: 'Tortolì - Sardinia',
  Trapani: 'Trapani - Sicily',
  Valledoria: 'Valledoria - Sardinia',
  Villasimius: 'Villasimius - Sardinia',
}
